import { atom } from 'recoil'

export type MetadataAtomType = {
  countries: {
    countryCode: string
    id: string
    latitude: number
    longitude: number
    timezone: string
    type: string
  }[]
}

const DEFAULT_STATE = {
  countries: [],
}

export const metadataAtom = atom<MetadataAtomType>({
  key: 'metadataState',
  default: DEFAULT_STATE,
})
